
import DtoTreePower from "@/models.machine/DtoTreePower";
import MiezzModal from "@/models/MiezzModal";
import { ElTree } from "element-plus";
import Node from "element-plus/es/components/tree/src/model/node";
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
export default class ChoosePower extends Vue {
  @Model() modal?: MiezzModal;
  @Model() modelValue: string[] = [];
  @Prop() tree: DtoTreePower[] = [];
  @Prop() showCheck?: boolean;
  props = {
    value: "Id",
    label: "Name",
    children: "Children",
    disabled: "Disabled",
    class: (data: any, node: any) => {
      return "tree-node";
    },
  };
  treeRef?: InstanceType<typeof ElTree>;

  id?: string;
  modalField = new MiezzModal();

  mounted(): void {
    this.treeRef = this.$refs["treeRef"] as InstanceType<typeof ElTree>;
  }

  @Watch("tree")
  onChanged(): void {
    this.treeRef?.setCheckedKeys(this.modelValue, false);
  }

  check(id: string, check?: boolean): void {
    const index = this.modelValue.indexOf(id);
    if (check && index == -1) {
      this.modelValue.push(id);
    } else if (!check && index > -1) {
      this.modelValue.splice(index, 1);
    }
  }
  /**菜单选择变化时 */
  handleCheckChange(
    data: DtoTreePower,
    checked: boolean,
    indeterminate: boolean
  ): void {
    if (!data.Id) return;
    data.Check = checked || indeterminate;
    this.check(data.Id, data.Check);
    if (
      data.RightItems &&
      data.RightItems.length > 0 &&
      // 菜单选中时 右侧全部未选中时 则右侧全选
      (!data.Check || data.RightItems.all((it) => !it.Check))
    ) {
      for (const item of data.RightItems) {
        if (item.Id && item.Check != data.Check) {
          item.Check = data.Check;
          this.check(item.Id, item.Check);
        }
      }
    }
    if (
      data.Children &&
      data.Children.length > 0 &&
      // 菜单选中时 子菜单全部未选中时 则子菜单全选
      (!data.Check || data.Children.all((it) => !it.Check))
    ) {
      for (const item of data.Children) {
        this.treeRef?.setChecked(item.Id as string, data.Check, false);
      }
    }
    // 菜单选中时 选中父菜单
    if (data.Check) {
      const node = this.treeRef?.getNode(data.Id);
      if (node?.parent && !node.parent.checked) {
        this.treeRef?.setChecked(node.parent.data.Id, true, false);
      }
    }
  }

  /**菜单右侧选择变化时 */
  handleNodeTagChange(data: DtoTreePower, node: Node): void {
    if (!data.Id) return;
    this.check(data.Id, data.Check);
    // 右侧选中时 并且 菜单未选中 则 选中菜单
    if (data.Check) {
      if (!node.data.Check) this.treeRef?.setChecked(node.data.Id, true, false);
    }
  }

  handleSubmit(): void {
    this.modalField.Show = false;
  }
}
